import languageCodes from '../constants/language-codes';
import playerStringNames from '../constants/player-string-names';
import localizationStrings from '../models/localization-strings';
import tabIndex from '../constants/tab-index';
import cssClasses from '../constants/css-classes';
import {escape} from './html-escape';
import audioDescriptionButtonTemplate from '../../../templates/audio_description_button_template.js';
import audioDescriptionTrackTemplate from '../../../templates/audio_description_track_template.js';
import beforeAfterPlayControlsTemplate from '../../../templates/before_after_play_controls_template.js';
import captionsButtonTemplate from '../../../templates/captions_button_template.js';
import choiceAnswerTemplate from '../../../templates/choice_answer_template.js';
import fillAnswerTemplate from '../../../templates/fill_answer_template.js';
import fullscreenControlTemplate from '../../../templates/fullscreen_control_template.js';
import screenReaderAlertTemplate from '../../../templates/screenreader_alert_template.js';
import hotspotViewTemplate from '../../../templates/hotspot_view_template.js';
import hotspotsTemplate from '../../../templates/hotspots_template.js';
import videoViewTemplate from '../../../templates/video_view_template.js';
import imageViewTemplate from '../../../templates/image_view_template.js';
import ioOverlayViewTemplate from '../../../templates/io_overlay_view_template.js';
import messageBarViewTemplate from '../../../templates/message_bar_view_template.js';
import openExternalLinkTemplate from '../../../templates/open_external_link_template.js';
import pipControlTemplate from '../../../templates/pip_control_template.js';
import playRewindControlsTemplate from '../../../templates/play_rewind_controls_template.js';
import preRollContainerTemplate from '../../../templates/pre_roll_container_template.js';
import prevNextControlsTemplate from '../../../templates/prev_next_controls_template.js';
import progressBarControlTemplate from '../../../templates/progress_bar_control_template.js';
import progressBarChapterSegmentTemplate from '../../../templates/progress-bar-chapter-segement_template.js';
import questionCountTemplate from '../../../templates/question_count_template.js';
import questionSetConfirmationTemplate from '../../../templates/question_set_confirmation_template.js';
import questionSetReviewConfirmationTemplate from '../../../templates/question_set_review_confirmation_template.js';
import questionSetReviewStatusTemplate from '../../../templates/question_set_review_status_template.js';
import questionSetTemplate from '../../../templates/question_set_template.js';
import questionTextTemplate from '../../../templates/question_text_template.js';
import questionFeedbackContextTextTemplate from '../../../templates/question_feedback_context_template.js';
import questionGradedStatusTemplate from '../../../templates/question_graded_status_template.js';
import quizSetupTemplate from '../../../templates/quiz_setup_template.js';
import settingsViewTemplate from '../../../templates/settings_view_template.js';
import shortAnswerTemplate from '../../../templates/short_answer_template.js';
import tocButtonTemplate from '../../../templates/toc_button_template.js';
import tocItemTemplate from '../../../templates/toc_item_template.js';
import tocTemplate from '../../../templates/toc_template.js';
import volumeControlTemplate from '../../../templates/volume_control_template.js';
import alertModalViewTemplate from '../../../templates/alert_modal_template.js';
import scormNavigationBarTemplate from '../../../templates/scorm_navigation_bar_template.js';
import scormConfirmCompleteModalTemplate from '../../../templates/scorm_confirm_complete_modal_template.js';
import scormSessionEndedTemplate from '../../../templates/scorm_session_ended_template.js';
import videoSeekingSpinnerViewTemplate from '../../../templates/video-seeking-spinner-view_template.js';
import playerLayoutTemplate from '../../../templates/player_layout_template';
import theaterModeButtonTemplate from '../../../templates/theater_mode_control_template';
import timeFormatter from './time-formatter.js';

var LOADER_IMG = 'data:image/gif;base64,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';
var PLACEHOLDER_GLYPH_DATA_URL = 'data:image/png;base64,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';
var SUBMITTING_GLYPH_DATA_URL = 'data:image/gif;base64,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';
var _videoId;

var generateAudioDescriptionButtonMarkup = function() {
   return audioDescriptionButtonTemplate({
      accessBtnAudioDescription: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnAudioDescription)),
      fullscreenIndex: tabIndex.DomOrder
   });
};

var generateAudioDescriptionTrackMarkup = function(audioDescriptionMediaSrc) {
   return audioDescriptionTrackTemplate({
      audioDescriptionTrackSrc: escape(audioDescriptionMediaSrc)
   });
};

var generateBeforeAfterPlayControlsMarkup = function() {
   var templateContext = {
      playIndex: tabIndex.DomOrder,
      replayIndex: tabIndex.DomOrder,
      playButtonIndex: tabIndex.DomOrder,
      replayButtonIndex: tabIndex.DomOrder,
      accessBtnClickToPlay: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnPlay)),
      accessBtnClickToReplay: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnClickToReplayLink))
   };

   return beforeAfterPlayControlsTemplate(templateContext);
};

var generateCaptionsButtonMarkup = function() {
   return captionsButtonTemplate({
      accessBtnClosedCaption: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnClosedCaption)),
      closedCaptionIndex: tabIndex.DomOrder
   });
};

var generateChoiceAnswersMarkup = function(questionText, questionAnswers, userResponse) {
   var templateContext = {};
   templateContext.questionText = escape(questionText);
   templateContext.answers = [];
   templateContext.placeHolderImg = PLACEHOLDER_GLYPH_DATA_URL;
   templateContext.focusableAnswerInput = cssClasses.focusableAnswerInput;

   questionAnswers.forEach(function(answer, index) {
      if (userResponse && index === parseInt(userResponse, 10)) {
         templateContext.answers.push({
            answerIndex: index,
            answer: escape(answer.text),
            isChecked: true
         });
      } else {
         templateContext.answers.push({
            answerIndex: index,
            answer: escape(answer.text)
         });
      }
   });

   return choiceAnswerTemplate(templateContext);
};

var generateFillInTheBlankAnswerMarkup = function(questionText, userResponse, autoFocus) {
   var templateContext = {};
   templateContext.questionText = escape(questionText);
   templateContext.inputLabel = 'Fill in question answer';
   templateContext.inputId = 'fill-in-the-blank-input';
   templateContext.inputName = 'fill-in-the-blank-input';
   templateContext.placeHolderImg = PLACEHOLDER_GLYPH_DATA_URL;
   templateContext.userResponse = escape(userResponse);
   templateContext.focusableAnswerInput = cssClasses.focusableAnswerInput;
   if (autoFocus) {
      templateContext.useAutofocus = 'true';
   }

   return fillAnswerTemplate(templateContext);
};

var generateFullscreenControlMarkup = function(buttonTitle) {
   return fullscreenControlTemplate({
      accessBtnFullScreen: escape(buttonTitle),
      fullscreenIndex: tabIndex.DomOrder
   });
};

var generateHotspotMarkup = function(hotspotContainerWidth, hotspotContainerHeight, hotspotIndex, descriptionId, hotspotDescription, hotspotShape, hotspotCoordinatesSeparationBySpace, hotspotLinkClassName) {
   return hotspotViewTemplate({
      hotspotContainerWidth: hotspotContainerWidth,
      hotspotContainerHeight: hotspotContainerHeight,
      hotspotIndex: hotspotIndex,
      hotspotDescriptionId: escape(descriptionId),
      hotspotDescription: escape(hotspotDescription),
      displayHotspotsShape: hotspotShape,
      hotspotCoordinatesSeparationBySpace: hotspotCoordinatesSeparationBySpace,
      hotspotLinkClassName: escape(hotspotLinkClassName)
   });
};

var generateScreenReaderAlertMarkup = function(screenReaderAlertText) {
   return screenReaderAlertTemplate({
      screenReaderAlertText: escape(screenReaderAlertText)
   });
};

var generateHotspotsMarkup = function(hotspotsContainerId) {
   return hotspotsTemplate({
      hotspotsContainerId: escape(hotspotsContainerId),
      hotspotsAltText: escape(localizationStrings.getPlayerString(playerStringNames.txtHotspot))
   });
};

var generateVideoViewMarkup = function(videoTagUniqueId) {
   _videoId = videoTagUniqueId;

   return videoViewTemplate({
      videoTagUniqueId: escape(videoTagUniqueId)
   });
};

var generateImageMarkup = function(mediaTagUniqueId) {
   return imageViewTemplate({
      mediaTagUniqueId: escape(mediaTagUniqueId)
   });
};

var generateIoOverlayMarkup = function() {
   return ioOverlayViewTemplate({
      loaderImg: LOADER_IMG,
      loaderAltText: escape(localizationStrings.getPlayerString(playerStringNames.videoLoading))
   });
};

var generateMessageBarMarkup = function(messageText, primaryActionButtonText) {
   return messageBarViewTemplate({
      messageText: messageText,
      primaryActionButtonText: escape(primaryActionButtonText)
   });
};

var generateOpenExternalLinkMarkup = function(link) {
   return openExternalLinkTemplate({
      link: escape(link),
      replayText: escape(localizationStrings.getPlayerString(playerStringNames.txtReplayVideo)),
      visitSiteText: escape(localizationStrings.getPlayerString(playerStringNames.txtVisitSite)),
      headerText: escape(localizationStrings.getPlayerString(playerStringNames.txtOpenLinkHeader)),
      subHeaderText: escape(localizationStrings.getPlayerString(playerStringNames.txtOpenLinkSubHeader)),
      screenReaderAlertText: escape(localizationStrings.getPlayerString(playerStringNames.confirmOpenUrlModalScreenReaderAlertText).replace('URL_TOKEN', link)),
      openButtonScreenReaderText: escape(localizationStrings.getPlayerString(playerStringNames.confirmOpenUrlConfirmButtonScreenReaderText))
   });
};

var generatePipControlMarkup = function(buttonTitle) {
   return pipControlTemplate({
      accessBtnPip: escape(buttonTitle),
      pipButtonIndex: tabIndex.DomOrder
   });
};

var generatePlayRewindControlsMarkup = function(skipDuration) {
   return playRewindControlsTemplate({
      accessBtnRewind: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnRewind).replace('{{duration}}', skipDuration)),
      accessBtnForward: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnForward).replace('{{duration}}', skipDuration)),
      accessBtnPlay: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnPlay)),
      rewindIndex: tabIndex.DomOrder,
      playIndex: tabIndex.DomOrder,
      forwardIndex: tabIndex.DomOrder
   });
};

var generatePlayerLayoutMarkup = function() {
   return playerLayoutTemplate({
      videoWrapperIndex: tabIndex.Disabled
   });
};

var generatePreRollMarkup = function(preRollSrc) {
   return preRollContainerTemplate({
      preRollSizeClass: 'preRoll-fullPage',
      preRollSrc: escape(preRollSrc)
   });
};

var generatePrevNextControlsMarkup = function() {
   return prevNextControlsTemplate({
      accessBtnPrevious: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnPrevious)),
      accessBtnNext: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnNext)),
      previousIndex: tabIndex.DomOrder,
      nextIndex: tabIndex.DomOrder
   });
};

var generateProgressBarMarkup = function() {
   return progressBarControlTemplate({
      progressIndex: tabIndex.DomOrder,
      accessBtnProgressBar: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnProgressBar))
   });
};

var generateProgressBarChapterSegmentMarkup = function(chapterIndex) {
   return progressBarChapterSegmentTemplate({
      chapterIndex: chapterIndex
   });
};

var generateQuestionTextMarkup = function(questionText, correctAnswerText) {
   var questionTextContext = {
      questionText: escape(questionText),
      correctAnswerText: escape(correctAnswerText)
   };

   return questionTextTemplate(questionTextContext);
};

var generateQuestionFeedbackContextMarkup = function(questionFeedbackContextText) {
   var questionFeedbackContextContext = {
      questionFeedbackContextText: escape(questionFeedbackContextText)
   };
   return questionFeedbackContextTextTemplate(questionFeedbackContextContext);
};

var generateQuestionGradedStatusMarkup = function() {
   var questionGradedStatusContext = {
      correctTextString: escape(localizationStrings.getPlayerString(playerStringNames.txtCorrectString)),
      incorrectTextString: escape(localizationStrings.getPlayerString(playerStringNames.txtIncorrectString))
   };

   return questionGradedStatusTemplate(questionGradedStatusContext);
};

var generateQuestionSetMarkup = function(quizTime) {
   var context = {
      previousButtonName: escape(localizationStrings.getPlayerString(playerStringNames.txtPrev)),
      previousQuestionButtonA11yText: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnPreviousQuestion)),
      nextButtonName: escape(localizationStrings.getPlayerString(playerStringNames.txtNext)),
      nextQuestionButtonA11yText: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnNextQuestion)),
      submitButtonName: escape(localizationStrings.getPlayerString(playerStringNames.txtSubmit)),
      continueButtonName: escape(localizationStrings.getPlayerString(playerStringNames.txtContinue)),
      hideQuizText: escape(localizationStrings.getPlayerString(playerStringNames.txtHideQuiz)),
      hideQuizA11yText: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnHideQuiz)),
      showQuizText: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnShowQuiz)),
      submittingImg: SUBMITTING_GLYPH_DATA_URL,
      submittingImgAltText: escape(localizationStrings.getPlayerString(playerStringNames.txtSubmittingAnswers)),
      quizTime: timeFormatter.formatTimeForReadability(quizTime),
      quizAtTimeHeading: escape(localizationStrings.getPlayerString(playerStringNames.quizAtTimeHeading)),
      videoId: _videoId
   };

   return questionSetTemplate(context);
};

var generateQuestionSetConfirmationMarkup = function(reviewText, confirmationText) {
   var context = {
      reviewText: escape(reviewText),
      confirmationText: escape(confirmationText),
      title: escape(localizationStrings.getPlayerString(playerStringNames.accessQuestionSetConfirmationTitle)),
      alertText: escape(localizationStrings.getPlayerString(playerStringNames.accessVideoPausedForQuiz))
   };

   return questionSetConfirmationTemplate(context);
};

var generateQuestionSetQuestionCountMarkup = function(currentQuestionNumber, totalQuestions) {
   var questionCountContext = {
      questionCountText: localizationStrings.getQuestionCountString(currentQuestionNumber, totalQuestions)
   };

   return questionCountTemplate(questionCountContext);
};

var generateQuestionSetReviewConfirmationMarkup = function(numberCorrectText, percentCorrectText, numberInCorrectText, percentInCorrectText, continueText, reviewText) {
   var context = {
      title: localizationStrings.getPlayerString(playerStringNames.accessQuizResults),
      alertText: numberCorrectText ? escape(`${numberCorrectText} ${percentCorrectText}. ${numberInCorrectText} ${percentInCorrectText}`) : null,
      numberCorrect: escape(numberCorrectText),
      percentCorrect: escape(percentCorrectText),
      numberInCorrect: numberInCorrectText,
      percentInCorrect: percentInCorrectText,
      continueText: escape(continueText),
      reviewAnswerText: escape(reviewText)
   };

   return questionSetReviewConfirmationTemplate(context);
};

var generateQuestionSetReviewStatusMarkup = function(gradableDetails, unGradeableDetails) {
   var context = {
      gradeableDetails: escape(gradableDetails),
      unGradeableDetails: escape(unGradeableDetails),
      txtAnswersSubmitted: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnAnswersSubmitted)),
      txtViewAnswers: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnShowAnswer)),
      txtHideAnswers: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnHideAnswer)),
      questionSetResultsTabIndex: tabIndex.DomOrder
   };

   return questionSetReviewStatusTemplate(context);
};

var generateQuizSetupMarkup = function() {
   var FIRST_NAME_CLASS = 'first_name';
   var LAST_NAME_CLASS = 'last_name';
   var reverseNames = localizationStrings.getLanguage() === languageCodes.JAPANESE;

   var setupMessage = localizationStrings.getPlayerString(playerStringNames.txtRequiredMessage);
   var enterEmail = localizationStrings.getPlayerString(playerStringNames.txtEnterEmail);
   var enterName1;
   var enterName2;
   var beginButtonText = localizationStrings.getPlayerString(playerStringNames.txtBegin);
   var skipControlText = localizationStrings.getPlayerString(playerStringNames.txtSkip);
   var name1Class;
   var name2Class;

   if (reverseNames) {
      enterName1 = localizationStrings.getPlayerString(playerStringNames.txtEnterLastName);
      enterName2 = localizationStrings.getPlayerString(playerStringNames.txtEnterFirstName);
      name1Class = LAST_NAME_CLASS;
      name2Class = FIRST_NAME_CLASS;
   } else {
      enterName1 = localizationStrings.getPlayerString(playerStringNames.txtEnterFirstName);
      enterName2 = localizationStrings.getPlayerString(playerStringNames.txtEnterLastName);
      name1Class = FIRST_NAME_CLASS;
      name2Class = LAST_NAME_CLASS;
   }

   var context = {
      setupMessage: setupMessage,
      enterName1: escape(enterName1),
      enterName2: escape(enterName2),
      name1Class: escape(name1Class),
      name2Class: escape(name2Class),
      enterEmail: escape(enterEmail),
      beginButtonText: escape(beginButtonText),
      skipControlText: escape(skipControlText)
   };

   return quizSetupTemplate(context);
};

var generateSettingsMarkup = function(hasMultipleLanguages, playbackRatesList, ccLanguageList, captionsExist, audioDescriptionMediaSrc) {
   const acknowledgmentUrl = 'https://www.techsmith.com/redirect.asp?target=SmartPlayerAcknowledgementLink&ver=1.0.0&lang=enu&os=na&product=smartplayer';

   var context = {
      accessBtnSettings: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnSettings)),
      settingsIndex: tabIndex.DomOrder,
      playerRateText: escape(localizationStrings.getPlayerString(playerStringNames.playerRateText)),
      speedSettingIndex: tabIndex.DomOrder,
      playbackRates: playbackRatesList,
      hasMultipleLanguages: hasMultipleLanguages,
      ccLanguageText: escape(localizationStrings.getPlayerString(playerStringNames.ccLanguageText)),
      ccLanguageSettingIndex: tabIndex.DomOrder,
      ccLanguages: ccLanguageList,
      accessBtnAudioDescription: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnAudioDescription)),
      audioDescriptionMediaSrc: audioDescriptionMediaSrc,
      captionsExist: captionsExist,
      accessPlayerSettingsClose: escape(localizationStrings.getPlayerString(playerStringNames.accessPlayerSettingsClose)),
      acknowledgementLinkName: localizationStrings.getPlayerString(playerStringNames.acknowledgementLinkName),
      acknowledgmentUrl: acknowledgmentUrl
   };

   return settingsViewTemplate(context);
};

var generateShortAnswerMarkup = function(questionText, userResponse, autoFocus) {
   var templateContext = {};
   templateContext.questionText = escape(questionText);
   templateContext.inputLabel = 'Supply your response';
   templateContext.inputId = 'short-answer-input';
   templateContext.inputName = 'short-answer-input';
   templateContext.userResponse = escape(userResponse);
   templateContext.focusableAnswerInput = cssClasses.focusableAnswerInput;
   if (autoFocus) {
      templateContext.useAutofocus = 'true';
   }

   return shortAnswerTemplate(templateContext);
};

var generateTocMarkup = function() {
   return tocTemplate({
      searchLabel: escape(localizationStrings.getPlayerString(playerStringNames.search)),
      msgSearch: escape(localizationStrings.getPlayerString(playerStringNames.searchPlaceholder)),
      msgSearchIsDisabledInFS: escape(localizationStrings.getPlayerString(playerStringNames.searchDisabledFullScreen)),
      accessBtnClearSearch: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnClearSearch)),
      searchOrJumpTo: escape(localizationStrings.getPlayerString(playerStringNames.searchOrJumpTo)),
      tocSearchIndex: tabIndex.DomOrder,
      tocEraseIndex: tabIndex.DomOrder
   });
};

var generateTocButtonMarkup = function() {
   return tocButtonTemplate({
      accessBtnTableOfContents: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnTableOfContents)),
      tocIndex: tabIndex.DomOrder
   });
};

var generateTocItemMarkup = function(dataTocTime, dataFileText, showThumbnail, centerContent, showText, tocText, tocRawText) {
   return tocItemTemplate({
      dataTocTime: dataTocTime,
      dataFileText: dataFileText,
      showThumbnail: showThumbnail,
      centerContent: centerContent,
      showText: showText,
      tocItemText: tocText,
      tocItemRawText: escape(tocRawText),
      tocItemIndex: tabIndex.DomOrder
   });
};

var generateVolumeControlMarkup = function(cachedVolume) {
   var VOLUME_SLIDER_MIN = 0;
   var VOLUME_SLIDER_MAX = 100;

   return volumeControlTemplate({
      accessBtnVolume: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnVolume)),
      volumeIndex: tabIndex.DomOrder,
      minVolume: VOLUME_SLIDER_MIN,
      maxVolume: VOLUME_SLIDER_MAX,
      currentVolume: cachedVolume,
      accessVolumeSlider: escape(localizationStrings.getPlayerString(playerStringNames.accessTxtVolume))
   });
};

var generateAlertModalMarkup = function(screenReaderAlertText, closeModalButtonTitle, modalTitle, modalContent, dismissButtonText, dismissButtonScreenReaderText, confirmButtonText, confirmButtonScreenReaderText) {
   return alertModalViewTemplate({
      screenReaderAlertText: escape(screenReaderAlertText),
      closeModalButtonTitle: escape(closeModalButtonTitle),
      modalTitle: escape(modalTitle),
      modalContent: modalContent,
      dismissButtonText: escape(dismissButtonText),
      dismissButtonScreenReaderText: escape(dismissButtonScreenReaderText),
      confirmButtonText: escape(confirmButtonText),
      confirmButtonScreenReaderText: escape(confirmButtonScreenReaderText)
   });
};

var generateScormNavigationBarMarkup = function(buttonLabel, isPrimaryButton) {
   return scormNavigationBarTemplate({
      completeSessionButtonLabel: escape(buttonLabel),
      isPrimaryButton: isPrimaryButton
   });
};

var generateScormConfirmCompleteModalMarkup = function(screenReaderAlertText, confirmText, dismissButtonText, dismissButtonScreenReaderText, confirmButtonText, confirmButtonScreenReaderText, isDestructiveButton) {
   return scormConfirmCompleteModalTemplate({
      screenReaderAlertText: escape(screenReaderAlertText),
      confirmText: confirmText,
      dismissButtonText: escape(dismissButtonText),
      dismissButtonScreenReaderText: escape(dismissButtonScreenReaderText),
      confirmButtonText: escape(confirmButtonText),
      confirmButtonScreenReaderText: escape(confirmButtonScreenReaderText),
      isDestructiveButton: escape(isDestructiveButton)
   });
};

var generateScormSessionEndedMarkup = function(sessionEndedText) {
   return scormSessionEndedTemplate({
      screenReaderAlertText: escape(sessionEndedText),
      scormSessionEndedText: escape(sessionEndedText)
   });
};

var generateVideoSeekingSpinnerViewTemplateMarkup = function() {
   return videoSeekingSpinnerViewTemplate({});
};

var generateTheaterModeButtonMarkup = function() {
   return theaterModeButtonTemplate({
      accessBtnTheaterMode: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnTheaterMode)),
      theaterModeIndex: tabIndex.DomOrder
   });
};

export default {
   generateAudioDescriptionButtonMarkup: generateAudioDescriptionButtonMarkup,
   generateAudioDescriptionTrackMarkup: generateAudioDescriptionTrackMarkup,
   generateBeforeAfterPlayControlsMarkup: generateBeforeAfterPlayControlsMarkup,
   generateCaptionsButtonMarkup: generateCaptionsButtonMarkup,
   generateChoiceAnswersMarkup: generateChoiceAnswersMarkup,
   generateFillInTheBlankAnswerMarkup: generateFillInTheBlankAnswerMarkup,
   generateFullscreenControlMarkup: generateFullscreenControlMarkup,
   generateHotspotMarkup: generateHotspotMarkup,
   generateScreenReaderAlertMarkup: generateScreenReaderAlertMarkup,
   generateHotspotsMarkup: generateHotspotsMarkup,
   generateVideoViewMarkup: generateVideoViewMarkup,
   generateImageMarkup: generateImageMarkup,
   generateIoOverlayMarkup: generateIoOverlayMarkup,
   generateMessageBarMarkup: generateMessageBarMarkup,
   generateOpenExternalLinkMarkup: generateOpenExternalLinkMarkup,
   generatePipControlMarkup: generatePipControlMarkup,
   generatePlayRewindControlsMarkup: generatePlayRewindControlsMarkup,
   generatePlayerLayoutMarkup: generatePlayerLayoutMarkup,
   generatePreRollMarkup: generatePreRollMarkup,
   generatePrevNextControlsMarkup: generatePrevNextControlsMarkup,
   generateProgressBarMarkup: generateProgressBarMarkup,
   generateProgressBarChapterSegmentMarkup: generateProgressBarChapterSegmentMarkup,
   generateQuestionTextMarkup: generateQuestionTextMarkup,
   generateQuestionFeedbackContextMarkup: generateQuestionFeedbackContextMarkup,
   generateQuestionGradedStatusMarkup: generateQuestionGradedStatusMarkup,
   generateQuestionSetConfirmationMarkup: generateQuestionSetConfirmationMarkup,
   generateQuestionSetQuestionCountMarkup: generateQuestionSetQuestionCountMarkup,
   generateQuestionSetMarkup: generateQuestionSetMarkup,
   generateQuestionSetReviewConfirmationMarkup: generateQuestionSetReviewConfirmationMarkup,
   generateQuestionSetReviewStatusMarkup: generateQuestionSetReviewStatusMarkup,
   generateQuizSetupMarkup: generateQuizSetupMarkup,
   generateSettingsMarkup: generateSettingsMarkup,
   generateShortAnswerMarkup: generateShortAnswerMarkup,
   generateTocButtonMarkup: generateTocButtonMarkup,
   generateTocItemMarkup: generateTocItemMarkup,
   generateTocMarkup: generateTocMarkup,
   generateVolumeControlMarkup: generateVolumeControlMarkup,
   generateAlertModalMarkup: generateAlertModalMarkup,
   generateScormNavigationBarMarkup: generateScormNavigationBarMarkup,
   generateScormConfirmCompleteModalMarkup: generateScormConfirmCompleteModalMarkup,
   generateScormSessionEndedMarkup: generateScormSessionEndedMarkup,
   generateVideoSeekingSpinnerViewTemplateMarkup: generateVideoSeekingSpinnerViewTemplateMarkup,
   generateTheaterModeButtonMarkup: generateTheaterModeButtonMarkup
};
